import React, { useEffect } from 'react';
import { FreeTrialNavigation } from './freetrial/FreeTrialNavigation';
import { FreeTrialHeader } from './freetrial/FreeTrialHeader';
import { FreeTrialContent } from './freetrial/FreeTrialContent';
import { FreeTrialFooter } from './freetrial/FreeTrialFooter';
export function FreeTrialPage() {
  useEffect(() => {
    document.title = "Free Trial | Walker's Martial Arts | Bloomington, Illinois";
  }, []);
  return <div className="bg-black min-h-screen" data-id="element-990">
      <FreeTrialNavigation data-id="element-991" />
      <FreeTrialHeader data-id="element-992" />
      <FreeTrialContent data-id="element-993" />
      <FreeTrialFooter data-id="element-994" />
    </div>;
}